import { toast, ToastOptions, TypeOptions } from "react-toastify";
import {ToastPosition} from "react-toastify/dist/types";

const AlertPosition: ToastPosition = "top-right";

const showToast = (message: string, type: TypeOptions = 'info', options: ToastOptions = {}) => {
    switch (type) {
        case 'info':
            toast.info(message, options);
            break;
        case 'success':
            toast.success(message, options);
            break;
        case 'error':
            toast.error(message, options);
            break;
        case 'warning':
            toast.warning(message, options);
            break;
        default:
            toast.dark(message, options);
            break;
    }
}
const closeAllToast = () => {
    toast.dismiss();
}

const updateToast = (toastId: any, message: string, type: TypeOptions = 'info', isLoading: boolean = false, options: ToastOptions = {}) => {
    const toastOptions: ToastOptions = {
        pauseOnFocusLoss: false,
        isLoading,
        autoClose: 5000,
        ...options,
    };
    switch (type) {
        case 'info':
            toast.update(toastId, {render: message, type: 'info', ...toastOptions});
            break;
        case 'success':
            toast.update(toastId, {render: message, type: 'success', ...toastOptions});
            break;
        case 'error':
            toast.update(toastId, {render: message, type: 'error', ...toastOptions});
            break;
        case 'warning':
            toast.update(toastId, {render: message, type: 'warning', ...toastOptions});
            break;
        default:
            toast.update(toastId, {render: message, type: 'default', ...toastOptions});
            break;
    }
}

const loadingToast = (message: string) => {
    return toast.loading(message);
}

const AlertService = {
    showToast,
    AlertPosition,
    updateToast,
    closeAllToast,
    loadingToast,
}

export default AlertService;
